// The "rowData" sessionStorage key is written by unrelated flows (patient
// object JSON, plain patientId string), so a naive JSON.parse can throw and
// crash the page that reads it next. Parse defensively instead.
export const safeParseSessionStorage = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch {
    return null;
  }
};
